import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import { PIXEL_TRACKING_KEYS } from "../constants/PixelTracking.constants";
import { useParams } from "react-router-dom";
import { useAccountSectionUnlocking } from "features/Account/utils/useAccountSectionChange";
import { UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL } from "features/AdminPanel/constants/AdminPanel.api";

export const usePixelTracking = () => {
  const sectionConfig = useAdminPanelStore((state) => state.sectionConfig);
  const overrideValue =
    sectionConfig[PIXEL_TRACKING_KEYS.OVERIDE_ACCOUNT_LEVEL_FB_TOKEN]?.value;
  const pixelIdValue = sectionConfig[PIXEL_TRACKING_KEYS.PIXEL_ID]?.value;
  const pixelTokenValue =
    sectionConfig[PIXEL_TRACKING_KEYS.PIXEL_ACESS_TOKEN]?.value;
  const { handleSectionChange } = useAccountSectionUnlocking();
  const { listing_uuid } = useParams();

  const onOverrideIDChange = () => {
    const payload = {
      listing_uuid,
      feature_key: PIXEL_TRACKING_KEYS.OVERIDE_ACCOUNT_LEVEL_FB_TOKEN,
      feature_value: !overrideValue,
    };
    handleSectionChange({
      endPoint: UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL,
      payload,
    });
    if (!overrideValue) {
      if (pixelIdValue) {
        handleSectionChange({
          endPoint: UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL,
          payload: {
            listing_uuid,
            feature_key: PIXEL_TRACKING_KEYS.PIXEL_ID,
            feature_value: pixelIdValue,
          },
        });
      }
      if (pixelTokenValue) {
        handleSectionChange({
          endPoint: UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL,
          payload: {
            listing_uuid,
            feature_key: PIXEL_TRACKING_KEYS.PIXEL_ACESS_TOKEN,
            feature_value: pixelTokenValue,
          },
        });
      }
    }
  };

  return { onOverrideIDChange };
};
